
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'


//车区列表
export function roadbookList(data) {
    return fetch({
        url: config.WEB_ROADBOOKLIST_API+"/"+data,
        method: 'GET',
    })
}